var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfileAvatar = function SvgProfileAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#0875E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9527 67.9508C66.6854 60.6781 62.9398 55.2095 54.7994 53.3367C53.4572 53.0246 53.0139 51.3016 54.1002 50.4464C56.7346 48.3676 58.6012 44.9903 59.0818 41.0324C59.8122 34.9895 55.8356 29.034 49.7178 28.1288C42.7572 27.0925 36.758 32.38 36.758 39.0223C36.758 43.8229 38.7806 48.0117 41.8395 50.4339C42.932 51.2954 42.5138 53.0246 41.1591 53.3367C33.0124 55.2095 29.2668 60.6719 27.9995 67.9508",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "profile_avatar.e60c2945d858b1a5d621c2b5353685de.svg";